module.exports = URL;


//////////////////
// WEBPACK FOOTER
// external "URL"
// module id = 134
// module chunks = 0